import React, {Component} from 'react'
import ResizeSensor from "resize-sensor"

class FJLayout extends Component {

	constructor(props) {
		super(props);
		this.container = React.createRef();
		this.state = {
			rects: [],
			containerHeight: 0,
		}
	}

	componentDidMount() {
		this.resizeSensor1 = new ResizeSensor(this.container.current, this.updateUI);
		this.resizeSensor2 = new ResizeSensor(document.body, this.updateUI);
		this.updateUI();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (((prevProps.active !== this.props.active) && this.props.active)
			|| (prevProps.sizes.length !== this.props.sizes.length)) {
			this.updateUI();
		}
	}

	componentWillUnmount() {
		this.resizeSensor1.detach();
		this.resizeSensor2.detach();
	}

	_indexOfMinHeight = (heights) => {
		let index = 0;
		let min = heights[index];
		heights.forEach((height, i) => {
			if (height < min) {
				min = height;
				index = i;
			}
		});

		return index;
	};

	_indexOfMaxHeight = (heights) => {
		let index = 0;
		let max = heights[index];
		heights.forEach((height, i) => {
			if (height > max) {
				max = height;
				index = i;
			}
		});

		return index;
	};

	updateUI = () => {
		let { space = 15, basicWidth = 336, minColumn = 3, sizes = [] } = this.props;
		let { width } = this.container.current.getBoundingClientRect();
		let column = Math.round((width + space) / (basicWidth + space));
		column = column < minColumn ? minColumn : column;
		let itemWidth = (width + space) / column - space;
		let heights = [];
		for (let i = 0; i < column; i++) {
			heights[i] = 0;
		}
		let rects = sizes.map(size => {
			let itemHeight = itemWidth / size.width * size.height;
			let index = this._indexOfMinHeight(heights);
			let spaceOffset = index * space - space / 2;
			let x = index * itemWidth + Math.max(0, spaceOffset);
			let y = heights[index];
			heights[index] = y + itemHeight + space;
			return {x, y, width: itemWidth, height: itemHeight};
		});
		this.setState({rects, containerHeight: heights[this._indexOfMaxHeight(heights)]});
	};

	render() {
		let { className, render } = this.props;
		let { rects, column, containerHeight } = this.state;
		return (
			<div ref={this.container}
			     style={{height: containerHeight}}
			     className={ className }>
				{ render(rects, column) }
			</div>
		);
	}
}

export default FJLayout;
